module.exports = __webpack_public_path__ + "assets/img/driver-btn-a1f11763.png";